import { HashtagsFragment, HashtagsQueryResult } from '@graphqlTypes/sitecore';
import { DeepReadonly } from '@src/utils/type-utils';
import { SettingPreferenceMapping } from './category-scores';

export function getAllHashtagScores(
    settingPreferenceMapping: DeepReadonly<SettingPreferenceMapping>,
    hashtag?: DeepReadonly<HashtagsQueryResult>
): Record<string, number> {
    const scores: Record<string, number> = {};
    hashtag?.Item?.data.forEach((tag) => {
        if (tag.key) {
            scores[tag.key] = getHashtagScoreByPreference(tag, settingPreferenceMapping);
        }
    });
    return scores;
}

function getHashtagScoreByPreference(
    tag: DeepReadonly<HashtagsFragment>,
    settingPreferenceMapping: DeepReadonly<SettingPreferenceMapping>
) {
    const defaultScore = tag.defaultScore?.numberValue || 0;
    let score = 0; // score = 0 when no preference in local setting

    if (settingPreferenceMapping.level?.hashTagsMap?.tags?.some((t) => t.name === tag.key)) {
        score += defaultScore;
    }

    //category score
    settingPreferenceMapping.category.forEach((preference) => {
        if (preference.hashTagsMap?.tags?.some((t) => t.name === tag.key)) {
            score += defaultScore;
        }
    });

    //interest score
    settingPreferenceMapping.interest.forEach((preference) => {
        if (preference.hashTagsMap?.tags?.some((t) => t.name === tag.key)) {
            score += defaultScore;
        }
    });

    //others score
    settingPreferenceMapping.others.forEach((preference) => {
        if (preference.hashTagsMap?.tags?.some((t) => t.name === tag.key)) {
            score += defaultScore;
        }
    });
    return score;
}
